module.exports = __webpack_public_path__ + "assets/icons/ic_email-876d.svg";